import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { keyframes } from '@emotion/react'
import { AppHeader } from '@/components/AppHeader/AppHeader'
import { AppNav } from '@/components/AppNav/AppNav'
import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundary'
import { Box } from '@mui/material'

export const Route = createRootRoute({
  component: RootLayout,
})

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
`

function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })

  return (
    <ErrorBoundary>
      <AppHeader />
      <Box sx={{ display: 'flex', minHeight: 'calc(100vh - 64px)' }}>
        <AppNav />
        <Box
          component="main"
          key={pathname}
          sx={{
            flexGrow: 1,
            p: { xs: 2, md: 3 },
            pb: { xs: '72px', md: 3 },
            animation: `${fadeIn} 0.18s ease-out`,
          }}
        >
          <Outlet />
        </Box>
      </Box>
      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </ErrorBoundary>
  )
}
